import React from "react";
import { TextField, Grid, Button, Typography } from "@material-ui/core";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _get from "lodash.get";
import SocialNetworkItem from "./socialNetworkItem";
import countries from "../../utils/countryCode";
import InputFileReader from "../fileReader";
import socialNetworks from "../../utils/socialNetworks";
import { styles } from "./styles";
import { withStyles } from "@material-ui/styles";
import { v4 as uuidv4 } from "uuid";

class CustomerFeedbackEditForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      data: {
        countryCode: "+84",
      },
      socialNetwork: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.uploadAvatar = this.uploadAvatar.bind(this);
  }
  handleChange(event) {
    const { name, value } = event.target;
    const { data } = this.state;
    this.setState({
      data: { ...data, [name]: value },
    });
    if (name === "socialNetwork") {
      this.setState({ [name]: value });
    }
  }
  async handleSubmit(event) {
    event.preventDefault();
    let { data } = this.state;
    const { feedback } = this.props;
    const code = uuidv4();
    let files = this.InputFileReader.getFile();
    if (files) {
      const avatar = await this.uploadAvatar({ files, feedback, code });
      data.avatar = avatar;
    }
    if (_get(feedback, "_id", false)) {
      await this.props.onSubmit({
        id: feedback._id,
        data,
      });
    } else {
      await this.props.onSubmit({ ...data, code });
    }
  }
  async uploadAvatar({ files, feedback, code }) {
    const response = await this.props.uploadAvatar({
      files: files,
      code: feedback.code || code,
      imgPre: "",
      type: "feedback",
    });
    if (response.code !== 1) {
      // handler error
    }
    return response.data.previewLink;
  }
  handleReset(event) {
    event.preventDefault();
    this.props.onReset();
  }
  render() {
    const { t, classes, feedback } = this.props;
    const { data } = this.state;
    const socialNetwork = this.state.socialNetwork
      ? this.state.socialNetwork
      : feedback.socialNetwork;

    return (
      <form onSubmit={this.handleSubmit} onReset={this.handleReset}>
        <Grid container spacing={3} justify="flex-start">
          <Grid item xs={12} sm={12} md={3}>
            <InputFileReader
              container="square"
              ratio={1}
              width={false}
              onRef={(id) => (this.InputFileReader = id)}
              style={classes}
              defaultImg={feedback.avatar}
              selectStorageMode={true}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={9}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12}>
                <TextField
                  id="name"
                  name="name"
                  label={t("name")}
                  defaultValue={feedback.name}
                  variant="outlined"
                  fullWidth={true}
                  required
                  onChange={this.handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <TextField
                  type="te"
                  name="text"
                  label={t("feedback")}
                  defaultValue={feedback.text}
                  variant="outlined"
                  fullWidth={true}
                  required
                  multiline
                  rows={4}
                  onChange={this.handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <TextField
                  id="email"
                  name="email"
                  label={t("email")}
                  defaultValue={feedback.email}
                  variant="outlined"
                  fullWidth={true}
                  type="email"
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={3}>
                    <TextField
                      select
                      label={t("countrycode_code")}
                      name="countryCode"
                      value={data.countryCode}
                      variant="outlined"
                      fullWidth={true}
                      onChange={this.handleChange}
                    >
                      {countries.map((option) => (
                        <option key={option.value} value={option.value}>
                          {`(${option.value}) ${option.country}`}
                        </option>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={12} md={9}>
                    <TextField
                      id="phone"
                      name="phone"
                      label={t("phone")}
                      defaultValue={feedback.phone}
                      variant="outlined"
                      fullWidth={true}
                      onChange={this.handleChange}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                {socialNetworks.map((item) => {
                  return (
                    <SocialNetworkItem
                      key={item.value}
                      socialNetwork={item}
                      defaultValue={socialNetwork}
                      value={feedback.socialNetwork[item.value]}
                      onChange={this.handleChange}
                    />
                  );
                })}
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <Grid container justify="flex-end">
                  <Button
                    type="reset"
                    style={{
                      marginRight: "16px",
                    }}
                    variant="contained"
                    color="secondary"
                  >
                    {t("cancel")}
                  </Button>
                  <Button type="submit" variant="contained" color="primary">
                    {t("save")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    );
  }
}
const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

CustomerFeedbackEditForm.propTypes = {
  feedback: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    countryCode: PropTypes.string,
    phone: PropTypes.string,
    createdAt: PropTypes.number,
  }),
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
};
export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(CustomerFeedbackEditForm)));
